import React, { useEffect, useState } from "react";
import { translate } from '../../../utils/language';
import { CloseButton } from '../../../assets/svgs'
import MyInput from '../../../components/ui/MyInput';
import PrimaryButton from '../../../components/ui/PrimaryButton';
import CreateAction from "../../../components/operational/createAction";
import countryCodes from '../../../utils/countryCodes.json'
import { Dropdown } from "primereact/dropdown";
import QRCode from "react-qr-code";
import { SVG_Copy_Linear } from "@dev-mobligo/iconpack";
import SecondaryButton from "../../../components/ui/SecondaryButton";
import { useNavigate } from "react-router-dom";

const DropdownItem = (item) => {
  return <div className=' p-1 text-sm flex flex-row gap-[5px]'>
    {item?.emoji}
    {"\t"}
    {item?.name}
  </div>
}

const countryOptions = countryCodes?.map(countryCode => { return { code: countryCode.iso2, name: countryCode.language, emoji: countryCode.emoji } })

function ThemesModalLanguageSelect({ isOpen, setIsOpen, themes, getThemes, theme }) {

  const storeId = localStorage.getItem('activeStoreId');
  const navigate = useNavigate()
  const [selectedLanguage, setSelectedLanguage] = useState()
  const [languageOptions, setLanguageOptions] = useState()
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [isCopiedText, setIsCopiedText] = useState(false);

  const setThemeId = () => {
    if (selectedLanguage?.theme?.id) {
      navigate(`/theme/${selectedLanguage?.theme?.id}`);


    }
  };

  const setDraftToLive = async (themeId) => {
    //@ts-ignore

    const response = await CreateAction({
      method: 'post',
      path: `/setDraftToLive/${themeId}`,
      showPreLoader: true,
      isFileUploading: false
    });

    if (response?.error) return { error: true };
    getThemes();
    return response;
  };

  useEffect(() => {

    if (theme?.themeData?.length > 0) {
      const optionData = theme?.themeData?.map((childTheme) => {
        const ThemeVariant = childTheme.ThemeVariant
        return {
          code: childTheme.id,
          name: ThemeVariant.name,
          isDraft: childTheme.isDraft,
          theme: childTheme
        }
      })?.filter(d => d)?.sort((a, b) => {
        const indexA = a.index
        const indexB = b.index
        return indexA - indexB
      })?.sort((a, b) => {
        const nameA = a.name
        const nameB = b.name
        return nameA.localeCompare(nameB)
      })

      setLanguageOptions(optionData)
      if (selectedLanguage) {
        const newSelectedLanguage = optionData?.find(data => data.code === selectedLanguage.code)
        return setSelectedLanguage(newSelectedLanguage)
      }
      setSelectedLanguage(optionData[0])
    }
  }, [theme])


  return (
    <>
      {isOpen && <div class="appear fixed inset-0 overflow-y-auto flex flex-col p-5 items-center  top-0 left-0 z-[50] justify-center">
        <div className='shadow' ></div>
        <div className="z-[500] bg-white p-8 h-[400px] w-[600px] rounded-xl   h-auto scrollbar-y-visible">
          <div className='flex flex-row flex-between w-full z-[500] items-center py-4'>
            {/* <div>{translate("editView")}</div> */}
            <div className='w-[250px] shrink-0'>Tema Dilini Seç</div>
            <div className='ml-auto cursor-pointer' onClick={() => setIsOpen(false)}>
              <CloseButton className={"fill-[#60646F]"}></CloseButton>
            </div>
          </div>
          <div className="flex flex-row gap-[30px]">
            <div className='flex flex-col w-full  shrink-0'>
              {countryCodes &&
                <Dropdown
                  filter
                  value={selectedLanguage}
                  className='w-full'
                  itemTemplate={DropdownItem}
                  options={languageOptions}
                  optionLabel='name'
                  onChange={(e) => {
                    setSelectedLanguage(e.value)
                  }}>

                </Dropdown>
              }
              <div className="flex items-center gap-[15px] pt-[15px] px-0">
                <PrimaryButton classes={'p-3'} onClick={setThemeId} value={'Temayı Özelleştir'} />
                <div className="relative">
                  <SecondaryButton
                    classes={'gap-[8px] items-center !bg-blue-500 text-white'}
                    svg={
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
                        <path
                          d="M2.01991 10.6366C1.33997 9.75328 1 9.3116 1 8.0001C1 6.6886 1.33997 6.24692 2.01991 5.36356C3.37757 3.59974 5.65449 1.6001 9 1.6001C12.3455 1.6001 14.6224 3.59974 15.9801 5.36356C16.66 6.24692 17 6.6886 17 8.0001C17 9.3116 16.66 9.75328 15.9801 10.6366C14.6224 12.4005 12.3455 14.4001 9 14.4001C5.65449 14.4001 3.37757 12.4005 2.01991 10.6366Z"
                          stroke="white"
                          stroke-width="1.5"
                        />
                        <path
                          d="M11.3996 8.0001C11.3996 9.32558 10.3251 10.4001 8.99961 10.4001C7.67413 10.4001 6.59961 9.32558 6.59961 8.0001C6.59961 6.67461 7.67413 5.6001 8.99961 5.6001C10.3251 5.6001 11.3996 6.67461 11.3996 8.0001Z"
                          stroke="white"
                          stroke-width="1.5"
                        />
                      </svg>
                    }
                    onClick={(e) => {
                      setDropdownOpen(state => !state);
                    }}
                    value={'Temayı Önizle'}
                    isDisabled={false}
                  />
                  {dropdownOpen && (
                    <div className="absolute left-[50%] translate-x-[-50%] top-[120%] py-[15px] rounded border-[1px] border-[#dbdbdb] bg-white w-[200px] flex items-center justify-center shadow-md bg-white z-[50] flex-col">
                      {/* Dropdown content goes here */}
                      <QRCode
                        size={256}
                        style={{ height: 'auto', maxWidth: '150px', width: '150px' }}
                        value={`${process.env.REACT_APP_API_URL}/getStoreTheme/${storeId}/${selectedLanguage?.theme?.id}`}
                        className="shrink-0"
                        viewBox={`0 0 256 256`}
                      ></QRCode>
                      <div className="text-[13px] text-[#8A92A6]  w-full p-3 break-word text-center">
                        Önizleme için karekodunuzu Mobligo uygulaması üzerinden taratınız.
                      </div>
                      <div
                        className={`flex items-center content-center gap-x-1 cursor-pointer`}
                        onClick={() => {
                          setIsCopiedText(!isCopiedText);
                          navigator.clipboard.writeText(
                            `${process.env.REACT_APP_API_URL}/getStoreTheme/${storeId}/${selectedLanguage?.theme?.id}`,
                          );
                        }}
                      >
                        <SVG_Copy_Linear
                          className={` ${isCopiedText ? 'stroke-emerald-500' : 'stroke-black'}`}
                        ></SVG_Copy_Linear>
                        <div className={` ${isCopiedText ? 'text-emerald-500' : 'color-black'}`}>
                          {isCopiedText ? 'Kopyalandı!' : 'Kopyala'}
                        </div>
                      </div>
                    </div>
                  )}
                </div>

                {selectedLanguage?.theme?.draftData && selectedLanguage?.theme?.isMain && (
                  <>
                    <PrimaryButton
                      confirmationMessage={'isDraftPublish'}
                      classes={'p-3 !bg-green-600'}
                      onClick={() => {
                        setDraftToLive(selectedLanguage?.theme?.id);
                      }}
                      value={'Temayı Güncelle'}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div >}
    </>
  )
}

export default ThemesModalLanguageSelect